import React, { useEffect, useState } from "react";
import AdminHead from "./AdminHead";
import { useParams, useNavigate } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../Components/Firebase";
import Loading from "../Components/Loading";
import "../Styles/Admin/ViewSapakOrders.css";

function ViewSapakOrders() {
  const { SUID, UID } = useParams();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState("all");
  const navigate = useNavigate();

  const statusOptions = [
    "all",
    "ממתין לאישור",
    "מאושר",
    "מבוטלת",
    "סופק",
    "נשלח",
    "בהכנה למשלוח",
    "נדרש תשלום"
  ];

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const q = query(
          collection(db, "Orders"),
          where("SapakId", "==", SUID)
        );

        const snapshot = await getDocs(q);

        // 🔽 SORT: NEW → OLD by orderNumber
        const ordersList = snapshot.docs
          .map(doc => ({
            id: doc.id,
            ...doc.data()
          }))
          .sort((a, b) => Number(b.orderNumber) - Number(a.orderNumber));

        setOrders(ordersList);
      } catch (error) {
        console.error("שגיאה בשליפת ההזמנות:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [SUID]);

  const getStatusClass = (status) => {
    switch (status) {
      case "ממתין לאישור":
        return "pending";
      case "מאושר":
        return "approved";
      case "מבוטלת":
        return "rejected";
      case "סופק":
        return "delivered";
      case "נשלח":
        return "shipped";
      case "בהכנה למשלוח":
        return "preparing";
      case "נדרש תשלום":
        return "payment";
      default:
        return "default";
    }
  };

  const filteredOrders =
    statusFilter === "all"
      ? orders
      : orders.filter(order => order.Status === statusFilter);

  if (loading) return <Loading />;

  return (
    <React.Fragment>
      <AdminHead />
      <div className="view-sapak-container" dir="rtl">
        <h1 className="view-sapak-title">הזמנות של סוכן</h1>

        <div className="sapak-actions">
          <button
            className="new-order-btn"
            onClick={() => {
              navigate(`/AdminHome/${SUID}/SCreateNewOrder`);
            }}
          >
            ➕ יצירת הזמנה חדשה
          </button>
        </div>

        {/* Status Filter */}
        <div className="status-filter">
          <label htmlFor="status-select">סנן לפי סטטוס:</label>
          <select
            id="status-select"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            {statusOptions.map((status, idx) => (
              <option key={idx} value={status}>
                {status === "all" ? "הצג הכל" : status}
              </option>
            ))}
          </select>
        </div>

        {filteredOrders.length === 0 ? (
          <p className="view-sapak-empty">לא נמצאו הזמנות.</p>
        ) : (
          filteredOrders.map(order => {
            const statusClass = getStatusClass(order.Status);

            return (
              <div key={order.id} className={`view-sapak-card ${statusClass}`}>
                <p><strong>מזהה הזמנה:</strong> {order.orderNumber}</p>
                <p><strong>סטטוס:</strong> {order.Status}</p>
                <p>
                  <strong>תאריך יצירה:</strong>{" "}
                  {order.createdAt?.toDate().toLocaleString()}
                </p>

                <button
                  className="view-order-btn"
                  onClick={() =>
                    navigate(
                      `/AdminHome/${UID}/ViewOrder/${order.CustomerID}/${order.id}`
                    )
                  }
                >
                  צפייה בהזמנה
                </button>
              </div>
            );
          })
        )}
      </div>
    </React.Fragment>
  );
}

export default ViewSapakOrders;
